import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.space',
    'resource:solutions.apps.space.pages.recordDetails',
    'resource:solutions.apps.space.pages.recordsList',
    'resource:solutions.apps.space',
  ],
  description: 'Standard Space',
  name: 'Space',
} as const satisfies core.quiver.Package
